"use client";

import { useTranslations } from "next-intl";

export default function AuthRightPanel() {
  const t = useTranslations("auth.passwordForget.rightPanel");
  return (
    <div className="to-primary-dark from-primary hidden bg-gradient-to-br lg:block lg:w-1/2">
      <div className="relative h-full w-full p-8">
        <div
          className="absolute inset-0 bg-cover bg-center opacity-20"
          style={{ backgroundImage: "url('/static/circles-logo.svg')" }}
        ></div>
        <div className="relative z-10 flex h-full flex-col items-center justify-center text-white">
          <h2 className="mb-4 text-2xl font-bold sm:text-3xl">{t("title")}</h2>
          <p className="mb-4 max-w-md text-center text-base sm:mb-8 sm:text-lg">
            {t("description")}
          </p>
          <div className="rounded-lg bg-white/10 p-4 backdrop-blur-sm sm:p-6">
            <blockquote className="italic">{t("quote")}</blockquote>
          </div>
        </div>
      </div>
    </div>
  );
}
